import type { SubscriptionSeat } from "lens-platform-sdk";

/**
 * Return the `SubscriptionSeat` that has lastest `createdAt` date
 */
export const getCurrentSubscriptionSeat = (subscriptionSeats: SubscriptionSeat[]) => {
  if (subscriptionSeats.length === 0) {
    return undefined;
  }

  const activeSeat = subscriptionSeats.find((seat) => seat.active === true);

  if (activeSeat) {
    return activeSeat;
  }

  return subscriptionSeats.reduce((previous, current) => {
    if (new Date(previous.createdAt).getTime() > new Date(current.createdAt).getTime()) {
      return previous;
    }

    return current;
  }, subscriptionSeats[0]);
};
